export default __webpack_public_path__ + "static/media/penToSquare.8d26df12.svg";